import styled from 'styled-components'

export const BannerContainer = styled.div`
  background-image: url('https://assets.ccbp.in/frontend/react-js/nxt-watch-banner-bg.png');
  background-size: cover;
  display: flex;
  justify-content: space-between;
  padding: 30px;
  align-items: flex-start;
  width: 100%;
`

export const BannerContentContainer = styled.div`
  width: 50%;
`

export const LogoImg = styled.img`
  width: 25%;
  min-width: 120px;
`

export const BannerContent = styled.p`
  color: #212121;
`

export const BannerDummyBtn = styled.button`
  border: 1px solid #212121;
  color: #212121;
  background-color: transparent;
  padding: 10px;
  margin-top: 20px;
  outline: none;
`

export const BannerCloseBtn = styled.button`
  border-width: 0;
  cursor: pointer;
  outline: none;
  background-color: transparent;
  font-size: 18px;
`
